import {
  TravelExpensesComment,
  TravelExpensesCommentInput
} from '../../../lib/types/models/travel-expenses/travel-expenses-comment'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createTravelExpensesComment = async (
  input: TravelExpensesCommentInput & { affectedStaffId: number }
) => {
  const { affectedStaffId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.createTravelExpensesComment.url, { affectedStaffId }))
    .post<TravelExpensesComment, TravelExpensesCommentInput>(data)
}
